export enum PlayerStatus {
    NULL = 0,
    LOADING,
    PLAYING,
    PAUSED,
    END,
}
